var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Collapse, Drawer, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Popover, Tooltip, Typography, useMediaQuery } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { assignedMenusByGroupURL, getUserProfileUrl } from "../../api/url";
import { BajajDrawerLogoIcon, DashboardIcon, FFRIcon, NineDotIcon, ReportIconActive, WorkshopIcon } from "../../assets/customIcons";
import { ReactComponent as BillingIcon } from '../../assets/images/currency-Icon.svg';
import { ArrowBackwardIcon, ArrowForwardIcon, BuildingIcon, ChevronDown, ChevronLeftNew, ChevronRightNew, ChevronUp, DashboardIconNew, ExcellonLogo, Finance, GridIcon, GridIconBlue, JournalVoucherBlue, JournalVoucherGrey, ReportIcon, Service, ShoppingCart, ShoppingCartBlue, SparePart, Vehicle, WorkshopIconBlue, WorkshopIconNew } from "../../assets/images";
import { CloseDrawerWidth, dateBeforeMonth, dateBeforeWeek, DrawerWidth, EUserRole, LOCAL_STORAGE_KEYS, versionNum } from "../../constants";
import { setIsLeftMenuOpen } from "../../redux/commonSlice";
import { getByIdAPI, getListAPI, setState } from "../../redux/crudSlice";
import { useAppDispatch } from "../../store/hooks";
import { systemColor } from "../../theme/systemColor";
import { getLocalStorageItem, setLocalStorageItem } from "../../utils/storageHelper";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import { MuiBox } from "../atoms/boxComponent";
import DrawerHeader from "../atoms/DrawerHeader";
import { MuiIconButton } from "../atoms/iconButtonComponent";
import { MuiStack } from "../atoms/stackComponent";
import Loader from "../molecules/loader";
import { setRbacStorage } from "../../builderPackage/rbac/rbac.entity";
var openedMixin = function (theme) { return ({
    width: DrawerWidth,
    transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
    }),
    overflowX: "hidden"
}); };
var closedMixin = function (theme) {
    var _a;
    return (_a = {
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            }),
            overflowX: "hidden",
            width: CloseDrawerWidth
        },
        _a[theme.breakpoints.up("sm")] = {
            width: CloseDrawerWidth
        },
        _a);
};
var DesktopDrawer = styled(MuiDrawer, {
    shouldForwardProp: function (prop) { return prop !== "open"; }
})(function (_ref) {
    var theme = _ref.theme, open = _ref.open;
    return _objectSpread(_objectSpread({
        width: DrawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
        boxSizing: "border-box"
    }, open && _objectSpread(_objectSpread({}, openedMixin(theme)), {}, {
        "& .MuiDrawer-paper": openedMixin(theme)
    })), !open && _objectSpread(_objectSpread({}, closedMixin(theme)), {}, {
        "& .MuiDrawer-paper": closedMixin(theme)
    }));
});
export var Sidebar = function (props) {
    var _assignedMenus$, _assignedMenusList$so, _storedSelectedBranch, _storedSelectedBranch2, _storedSelectedBranch3, _modules, _modules2, _subMenuList$sort2;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var desktopOpen = props.desktopOpen, handleDesktopOpen = props.handleDesktopOpen, mobileOpen = props.mobileOpen, handleMobileOpen = props.handleMobileOpen;
    var _a = useState(""), selectedMenuItem = _a[0], setSelectedMenuItem = _a[1];
    var assignedMenus = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var _b = useState(), subMenuList = _b[0], setSubMenuList = _b[1];
    var _c = useState(''), selectedSubMenuItem = _c[0], setSelectedSubMenuItem = _c[1];
    var role = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var safeAreaMargin = useSelector(function (state) {
        var _state$common;
        return (_state$common = state.common) === null || _state$common === void 0 ? void 0 : _state$common.safeAreaMargin;
    });
    var _d = useState(assignedMenus !== null && assignedMenus !== void 0 ? assignedMenus : []), assignedMenusList = _d[0], setAssignedMenusList = _d[1];
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var _e = useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var open = Boolean(anchorEl);
    var commonState = useSelector(function (state) { return state.common; });
    var _f = useState(null), dotgridIconAnchorEl = _f[0], setdotgridIconAnchorEl = _f[1];
    var openNewDocumentsMenu = Boolean(dotgridIconAnchorEl);
    var assignModuleData = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MODULEDATA);
    var selectedDesignation = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var userData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var trackButtonClick = useAnalyticsEventTracker("Sidebar");
    useEffect(function () {
        initialApiCall();
    }, [window.location.pathname, assignedMenus && ((_assignedMenus$ = assignedMenus[0]) === null || _assignedMenus$ === void 0 ? void 0 : _assignedMenus$.Name)]);
    var initialApiCall = function () {
        if (assignedMenus != null || assignedMenus != undefined || (assignedMenus === null || assignedMenus === void 0 ? void 0 : assignedMenus.length) > 0) {
            var path_1 = window.location.pathname.substring(1).toLowerCase();
            setAssignedMenusList(assignedMenus);
            assignedMenus.map(function (menu) {
                var lowercasePaths = menu.Menus.map(function (m) { return m === null || m === void 0 ? void 0 : m.Routes.toLowerCase(); });
                var updatedPath;
                var filter = lowercasePaths.map(function (item) {
                    if (item.includes('/')) {
                        updatedPath = item === null || item === void 0 ? void 0 : item.slice(1, item.length);
                    }
                    else {
                        updatedPath = item;
                    }
                    return updatedPath;
                });
                if (filter.includes(path_1)) {
                    var _menu$DisplayName;
                    setSelectedMenuItem((_menu$DisplayName = menu.DisplayName) !== null && _menu$DisplayName !== void 0 ? _menu$DisplayName : "");
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_MENU, menu);
                    var normalizedPath_1 = "/".concat(path_1.toLowerCase());
                    (menu === null || menu === void 0 ? void 0 : menu.Menus) && (menu === null || menu === void 0 ? void 0 : menu.Menus.forEach(function (elem) {
                        if ((elem === null || elem === void 0 ? void 0 : elem.Routes.toLowerCase()) === normalizedPath_1) {
                            var _elem$DisplayName;
                            setSelectedSubMenuItem((_elem$DisplayName = elem === null || elem === void 0 ? void 0 : elem.DisplayName) !== null && _elem$DisplayName !== void 0 ? _elem$DisplayName : "");
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_SUB_MENU, elem);
                        }
                    }));
                    return true;
                }
                return false;
            });
        }
    };
    var onClickDrawerMenus = function (item, index) {
        setSelectedMenuItem(item === null || item === void 0 ? void 0 : item.DisplayName);
        trackButtonClick("ButtonClickEvent", "Drawer_Click_" + "".concat(item === null || item === void 0 ? void 0 : item.Name), undefined);
        setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_MENU, item);
        var updatedList = __spreadArray([], assignedMenusList, true);
        if (item.Menus.length > 0) {
            updatedList = updatedList.map(function (itemList, itemIndex) { return itemIndex == index ? _objectSpread(_objectSpread({}, itemList), {}, {
                isSubMenuOpen: !itemList.isSubMenuOpen
            }) : _objectSpread(_objectSpread({}, itemList), {}, {
                isSubMenuOpen: false
            }); });
            setSubMenuList(item.Menus);
        }
        else {
            setSubMenuList([]);
            navigate(item.Routes);
        }
        setAssignedMenusList(updatedList);
    };
    var onClickModuleSubMenus = function (item) {
        var _item$Features;
        setSelectedSubMenuItem(item.DisplayName);
        trackButtonClick("ButtonClickEvent", "Drawer_Click_" + "".concat(item === null || item === void 0 ? void 0 : item.Name), undefined);
        setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_SUB_MENU, item);
        setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE, (_item$Features = item.Features) !== null && _item$Features !== void 0 ? _item$Features : []);
        var variant = (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.FinalInspector ? "Job card" : "Appointments";
        setLocalStorageItem(LOCAL_STORAGE_KEYS.DASHBOARD_SELECTED_VARIANT, variant);
        setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE, (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FloorSupervisor ? dateFormate(dateBeforeMonth) : dateFormate(dateBeforeWeek));
        setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE, dateFormate(new Date()));
        navigate(item.Routes);
        if (!lgMode) {
            handleMobileOpen(false);
        }
        dispatch(setState({
            key: "filterValue",
            value: {}
        }));
        dispatch(setState({
            key: "fromDashboard",
            value: false
        }));
        var filterMasterNull = ["repairTypeList", "vehicleList", "statusList", "advisorList"];
        var value = filterMasterNull.map(function (item) {
            dispatch(setState({
                key: item,
                value: []
            }));
        });
        handleClose();
    };
    var formateDdMm = function (item) {
        if (item < 10) {
            return "0".concat(item);
        }
        else {
            return item;
        }
    };
    var dateFormate = function (date) {
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var objectDate = new Date(date);
        var d = objectDate.getDate();
        var month = monthNames[objectDate.getMonth()];
        var y = objectDate.getFullYear();
        var dd = formateDdMm(d);
        return "".concat(month, " ").concat(dd, ", ").concat(y);
    };
    var getIconImages = function (item) {
        switch (item.DisplayName.toUpperCase().trim()) {
            case 'DASHBOARD':
            case 'SERVICE CRM':
                return /*#__PURE__*/ React.createElement(React.Fragment, null, ["Dashboard", "Service CRM"].includes(selectedMenuItem) ? /*#__PURE__*/ React.createElement(DashboardIcon, {
                    id: "dashboard-icon",
                    sx: {
                        stroke: systemColor.primary
                    }
                }) : /*#__PURE__*/ React.createElement("img", {
                    id: "dashboard-icon",
                    alt: "dashboard",
                    width: 24,
                    height: 24,
                    src: DashboardIconNew
                }));
            case 'WORKSHOP':
                return /*#__PURE__*/ React.createElement(React.Fragment, null, selectedMenuItem === "Workshop" ? /*#__PURE__*/ React.createElement(WorkshopIcon, {
                    id: "workshop-icon",
                    sx: {
                        stroke: systemColor.primary
                    }
                }) : /*#__PURE__*/ React.createElement("img", {
                    width: 24,
                    height: 24,
                    src: WorkshopIconNew,
                    alt: "workshop",
                    id: "workshop-icon"
                }));
            case 'INSIGHTS':
                return /*#__PURE__*/ React.createElement(React.Fragment, null, selectedMenuItem === "Insights" ? /*#__PURE__*/ React.createElement(ReportIconActive, {
                    id: "report-icon",
                    sx: {
                        fill: systemColor.primary
                    }
                }) : /*#__PURE__*/ React.createElement("img", {
                    width: 24,
                    height: 24,
                    src: ReportIcon,
                    alt: "Insights",
                    id: "report-icon"
                }));
            case 'VEHICLE':
                return /*#__PURE__*/ React.createElement("img", {
                    width: 24,
                    height: 24,
                    src: selectedMenuItem === "Vehicle" ? WorkshopIconBlue : WorkshopIconNew,
                    alt: "Vehicle",
                    id: "workshop-icon"
                });
            case 'INVENTORY':
                return /*#__PURE__*/ React.createElement("img", {
                    width: 24,
                    height: 24,
                    src: selectedMenuItem === "Inventory" ? GridIconBlue : GridIcon,
                    alt: "Inventory",
                    id: "inventory-icon"
                });
            case 'JOURNAL':
                return /*#__PURE__*/ React.createElement("img", {
                    width: 24,
                    height: 24,
                    src: selectedMenuItem === "Journal" ? JournalVoucherBlue : JournalVoucherGrey,
                    alt: "Journal",
                    id: "Journal-icon"
                });
            case 'PROCUREMENT':
                return /*#__PURE__*/ React.createElement("img", {
                    width: 24,
                    height: 24,
                    src: selectedMenuItem === "Procurement" ? ShoppingCartBlue : ShoppingCart,
                    alt: "Procurement",
                    id: "Procurement-icon"
                });
            case 'BILLING':
                return /*#__PURE__*/ React.createElement(React.Fragment, null, selectedMenuItem === "Billing" ? /*#__PURE__*/ React.createElement(BillingIcon, {
                    id: "currency-rupee-circle",
                    color: systemColor.primary,
                    height: 24,
                    width: 24
                }) : /*#__PURE__*/ React.createElement(BillingIcon, {
                    height: 24,
                    width: 24,
                    id: "currency-rupee-circle"
                }));
            case 'FIELD FAILURE':
                return /*#__PURE__*/ React.createElement(React.Fragment, null, selectedMenuItem === "Field Failure" ? /*#__PURE__*/ React.createElement(FFRIcon, {
                    id: "dashboard-icon",
                    sx: {
                        stroke: systemColor.primary
                    }
                }) : /*#__PURE__*/ React.createElement(FFRIcon, {
                    id: "dashboard-icon"
                }));
            case 'FIELD FAILURE PSG':
                return /*#__PURE__*/ React.createElement(React.Fragment, null, selectedMenuItem === "Field Failure" ? /*#__PURE__*/ React.createElement(FFRIcon, {
                    id: "dashboard-icon",
                    sx: {
                        stroke: systemColor.primary
                    }
                }) : /*#__PURE__*/ React.createElement(FFRIcon, {
                    id: "dashboard-icon"
                }));
            default:
                /*#__PURE__*/ React.createElement("img", {
                    width: 24,
                    height: 24,
                    alt: "default"
                });
        }
    };
    var handleRedirection = function () {
        trackButtonClick("ButtonClickEvent", 'Drawer_Click_ExcellonIcon', undefined);
        window.open('https://www.excellonsoft.com/', '_blank'); // Open the URL in a new tab
    };
    var handleClose = function () {
        setAnchorEl(null);
        var updatedList = __spreadArray([], assignedMenusList, true);
        updatedList = updatedList.map(function (itemList, itemIndex) {
            return _objectSpread(_objectSpread({}, itemList), {}, {
                isSubMenuOpen: false
            });
        });
        setAssignedMenusList(updatedList);
    };
    var handleClick = function (event, item, index) {
        trackButtonClick("ButtonClickEvent", "Drawer_Click_" + "".concat(item === null || item === void 0 ? void 0 : item.Name) + '_Expand', undefined);
        setAnchorEl(event.currentTarget);
        onClickDrawerMenus(item, index);
    };
    var handleDotGridMenu = function () {
        trackButtonClick("ButtonClickEvent", "Drawer_Mobile_NineDot_Close", undefined);
        setdotgridIconAnchorEl(null);
    };
    var arr = [{
            name: 'Service',
            src: Service
        }, {
            name: 'Vehicle',
            src: Vehicle
        }, {
            name: 'Spare parts',
            src: SparePart
        }, {
            name: 'Financials',
            src: Finance
        }];
    var modules = function (data) {
        var modulesList = [];
        data === null || data === void 0 || data.map(function (itemValue) {
            var finalArr = arr === null || arr === void 0 ? void 0 : arr.find(function (item) { return item.name === itemValue.DisplayName; });
            if (finalArr) {
                modulesList.push(_objectSpread(_objectSpread({}, itemValue), {}, {
                    src: finalArr.src
                }));
            }
        });
        return modulesList;
    };
    var onModuleClickImage = function (event, item, i) { return __awaiter(void 0, void 0, void 0, function () {
        var _profileDetailsRespon, _moduleMenuListRespon, _moduleMenuListRespon2, _assignModuleData$i, profileDetailsResponse, resultedRole, body, moduleMenuListResponse, _moduleMenuListRespon3, _moduleMenuListRespon4, updatedList, MenuSequence, newList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "Drawer_Mobile_Module_" + "".concat(item === null || item === void 0 ? void 0 : item.Name), undefined);
                    profileDetailsResponse = dispatch(getByIdAPI({
                        key: "",
                        url: getUserProfileUrl
                    }));
                    resultedRole = selectedDesignation && selectedDesignation.Name ? selectedDesignation : profileDetailsResponse === null || profileDetailsResponse === void 0 || (_profileDetailsRespon = profileDetailsResponse.payload) === null || _profileDetailsRespon === void 0 || (_profileDetailsRespon = _profileDetailsRespon.data) === null || _profileDetailsRespon === void 0 ? void 0 : _profileDetailsRespon.AssignedRole[0];
                    body = {
                        ModuleId: item === null || item === void 0 ? void 0 : item.ModuleId,
                        RoleId: resultedRole.RoleId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "assignMenusByGroupData",
                            url: assignedMenusByGroupURL,
                            request: body
                        }))];
                case 1:
                    moduleMenuListResponse = _a.sent();
                    if (moduleMenuListResponse !== null && moduleMenuListResponse !== void 0 && (_moduleMenuListRespon = moduleMenuListResponse.payload) !== null && _moduleMenuListRespon !== void 0 && _moduleMenuListRespon.value.success && moduleMenuListResponse !== null && moduleMenuListResponse !== void 0 && (_moduleMenuListRespon2 = moduleMenuListResponse.payload) !== null && _moduleMenuListRespon2 !== void 0 && (_moduleMenuListRespon2 = _moduleMenuListRespon2.value) !== null && _moduleMenuListRespon2 !== void 0 && _moduleMenuListRespon2.data) {
                        setRbacStorage(moduleMenuListResponse === null || moduleMenuListResponse === void 0 || (_moduleMenuListRespon3 = moduleMenuListResponse.payload) === null || _moduleMenuListRespon3 === void 0 || (_moduleMenuListRespon3 = _moduleMenuListRespon3.value) === null || _moduleMenuListRespon3 === void 0 ? void 0 : _moduleMenuListRespon3.data);
                        setdotgridIconAnchorEl(null);
                        updatedList = moduleMenuListResponse === null || moduleMenuListResponse === void 0 || (_moduleMenuListRespon4 = moduleMenuListResponse.payload) === null || _moduleMenuListRespon4 === void 0 || (_moduleMenuListRespon4 = _moduleMenuListRespon4.value) === null || _moduleMenuListRespon4 === void 0 || (_moduleMenuListRespon4 = _moduleMenuListRespon4.data) === null || _moduleMenuListRespon4 === void 0 ? void 0 : _moduleMenuListRespon4.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                            isSubMenuOpen: false
                        }); });
                        MenuSequence = updatedList === null || updatedList === void 0 ? void 0 : updatedList.sort(function (a, b) { return a.Sequence - b.Sequence; });
                        newList = MenuSequence.map(function (item) {
                            var subMenus = __spreadArray([], item.Menus, true);
                            var SubMenusSequence = subMenus === null || subMenus === void 0 ? void 0 : subMenus.sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, item), {}, {
                                Menus: SubMenusSequence
                            });
                        });
                        dispatch(setState({
                            key: LOCAL_STORAGE_KEYS.ASSIGNED_MENUS,
                            value: newList
                        }));
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS, newList);
                    }
                    switch ((_assignModuleData$i = assignModuleData[i]) === null || _assignModuleData$i === void 0 ? void 0 : _assignModuleData$i.Name) {
                        case 'Service':
                            return [2 /*return*/, navigate("/dashboard")];
                        case 'Vehicle':
                            return [2 /*return*/, navigate("/vehicle")];
                        case "Financials":
                            return [2 /*return*/, navigate("/journalVoucher")];
                        case 'SpareParts':
                            return [2 /*return*/, navigate("/spareParts/dashboard")];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var newDrawerContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(List, null, assignedMenusList.length > 0 && (assignedMenusList === null || assignedMenusList === void 0 || (_assignedMenusList$so = assignedMenusList.sort(function (a, b) { return a.Sequence - b.Sequence; })) === null || _assignedMenusList$so === void 0 ? void 0 : _assignedMenusList$so.map(function (item, index) {
        var _subMenuList$sort;
        return /*#__PURE__*/ React.createElement(ListItem, {
            dense: true,
            alignItems: "center",
            sx: {
                ":hover": {
                    cursor: "default"
                },
                paddingX: 1
            },
            onClick: function () { return onClickDrawerMenus(item, index); }
        }, /*#__PURE__*/ React.createElement(ListItemButton, {
            disableTouchRipple: true,
            sx: {
                minHeight: 40,
                justifyContent: {
                    sm: desktopOpen ? "initial" : "center",
                    xs: "initial"
                },
                backgroundColor: item.DisplayName == selectedMenuItem ? "#F0F8FF" : "transparent",
                borderRadius: "8px"
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            flexDirection: 'row',
            justifyContent: "space-between",
            alignItems: 'center'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: 2
        }, /*#__PURE__*/ React.createElement(ListItemIcon, {
            sx: {
                minWidth: 0,
                mr: {
                    sm: desktopOpen ? 1 : "auto",
                    xs: 3
                },
                justifyContent: "center",
                marginTop: '3px'
            }
        }, getIconImages(item)), /*#__PURE__*/ React.createElement(ListItemText, {
            sx: {
                opacity: {
                    sm: desktopOpen ? 1 : 0,
                    xs: 1
                }
            },
            primary: /*#__PURE__*/ React.createElement(Typography, {
                fontSize: "lg",
                fontWeight: "strong",
                color: selectedMenuItem == (item === null || item === void 0 ? void 0 : item.DisplayName) ? "primary" : 'text.primary',
                id: "".concat(item.DisplayName, "-menu")
            }, item === null || item === void 0 ? void 0 : item.DisplayName)
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'right'
        }, (item === null || item === void 0 ? void 0 : item.Menus) && (item.isSubMenuOpen ? /*#__PURE__*/ React.createElement(MuiIconButton, {
            size: "small"
        }, /*#__PURE__*/ React.createElement("img", {
            src: ChevronUp,
            alt: "collapse"
        })) : /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "exapandMoreIcon",
            size: "small"
        }, /*#__PURE__*/ React.createElement("img", {
            src: ChevronDown,
            alt: "collapse"
        }))))), 
        /*#__PURE__*/
        // subMenuList && item?.DisplayName === selectedMenuItem && (
        React.createElement(Collapse, {
            in: item.isSubMenuOpen,
            timeout: "auto",
            unmountOnExit: true
        }, /*#__PURE__*/ React.createElement(List, {
            component: "div",
            disablePadding: true,
            sx: {
                marginTop: '5px'
            }
        }, subMenuList === null || subMenuList === void 0 || (_subMenuList$sort = subMenuList.sort(function (a, b) { return a.Sequence - b.Sequence; })) === null || _subMenuList$sort === void 0 ? void 0 : _subMenuList$sort.map(function (item, index) { /*#__PURE__*/ return React.createElement(ListItem, {
            key: index,
            onClick: function () { return onClickModuleSubMenus(item); },
            disableGutters: true,
            dense: true,
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(ListItemButton, {
            sx: {
                minHeight: 40,
                // justifyContent: 'flex-end',
                borderRadius: "8px"
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            marginRight: "3px",
            height: 24,
            width: 24
        }), /*#__PURE__*/ React.createElement(ListItemText, {
            sx: {
                opacity: {
                    sm: desktopOpen ? 1 : 0,
                    xs: 1
                }
            },
            primary: /*#__PURE__*/ React.createElement(Typography, {
                fontSize: "lg",
                fontWeight: "strong",
                color: selectedSubMenuItem === item.DisplayName ? "primary" : 'text.primary',
                id: item.DisplayName === "Vehicle Inspection" ? "Draft Job Card" : item.DisplayName
            }, item.DisplayName)
        }))); })))
        // )
        )));
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            display: "flex",
            flexGrow: 1
        },
        direction: "column",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(ListItem, {
        disablePadding: true,
        sx: {
            display: "block"
        }
        // onClick={(e: any) => onChangePage("Signout")}
    }, /*#__PURE__*/ React.createElement(ListItemButton, {
        sx: {
            minHeight: 48,
            justifyContent: {
                sm: desktopOpen ? "initial" : "center",
                xs: "initial"
            },
            backgroundColor: "transparent",
            borderRadius: "8px"
        },
        onClick: handleRedirection
    }, /*#__PURE__*/ React.createElement(ListItemIcon, {
        sx: {
            minWidth: 0,
            mr: {
                sm: desktopOpen ? 1 : "auto",
                xs: 3
            },
            justifyContent: "center",
            "&.MuiListItemIcon-root": {
                marginRight: 1
            }
        }
    }, /*#__PURE__*/ React.createElement("img", {
        width: 36,
        height: 36,
        src: ExcellonLogo,
        alt: "excellon-logo",
        id: "excellon-logo"
    })), /*#__PURE__*/ React.createElement(ListItemText, {
        sx: {
            opacity: {
                sm: desktopOpen ? 1 : 0,
                xs: 1
            }
        },
        primary: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                display: "inline",
                color: "#A8B5C2"
            },
            variant: "h2"
        }, t("Powered by Excellon"))),
        secondary: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                display: "inline",
                color: "#505862"
            },
            variant: "h6"
        }, versionNum.version))
    })))));
    var newDrawerContentDesktopView = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(List, {
        sx: {
            px: 1
        }
    }, assignedMenusList.length > 0 && assignedMenusList.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(ListItem, {
            alignItems: "center",
            dense: true,
            disableGutters: true,
            onClick: function (event) {
                handleClick(event, item, index);
            }
        }, /*#__PURE__*/ React.createElement(ListItemButton, {
            disableTouchRipple: true,
            sx: {
                minHeight: 40,
                justifyContent: {
                    sm: desktopOpen ? "initial" : "center",
                    xs: "initial"
                },
                backgroundColor: item.DisplayName == selectedMenuItem ? 'primary.50' : "transparent",
                borderRadius: "8px"
            }
        }, /*#__PURE__*/ React.createElement(ListItemIcon, {
            sx: {
                minWidth: 0,
                mr: {
                    sm: desktopOpen ? 1 : "auto",
                    xs: 3
                },
                justifyContent: "center"
            }
        }, getIconImages(item)), /*#__PURE__*/ React.createElement(ListItemText, {
            sx: {
                opacity: {
                    sm: desktopOpen ? 1 : 0,
                    xs: 1
                }
            },
            primary: /*#__PURE__*/ React.createElement(Typography, {
                fontSize: "lg",
                fontWeight: "strong",
                color: selectedMenuItem == (item === null || item === void 0 ? void 0 : item.DisplayName) ? 'primary.main' : 'text.primary',
                id: "".concat(item.DisplayName, "-menu")
            }, item === null || item === void 0 ? void 0 : item.DisplayName)
        }), desktopOpen && /*#__PURE__*/ React.createElement(MuiStack, {
            marginLeft: '20px'
        }, (item === null || item === void 0 ? void 0 : item.Menus) && (item.isSubMenuOpen ? /*#__PURE__*/ React.createElement(MuiIconButton, {
            size: "small"
        }, /*#__PURE__*/ React.createElement("img", {
            src: ChevronLeftNew,
            alt: "collapse"
        })) : /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "exapandMoreIcon",
            size: "small"
        }, /*#__PURE__*/ React.createElement("img", {
            src: ChevronRightNew,
            alt: "collapse"
        }))))));
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            display: "flex",
            flexGrow: 1
        },
        direction: "column",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(ListItem, {
        disablePadding: true,
        sx: {
            display: "block"
        }
        // onClick={(e: any) => onChangePage("Signout")}
    }, /*#__PURE__*/ React.createElement(ListItemButton, {
        sx: {
            minHeight: 48,
            justifyContent: {
                sm: desktopOpen ? "initial" : "center",
                xs: "initial"
            },
            backgroundColor: "transparent",
            borderRadius: "8px"
        },
        onClick: handleRedirection
    }, /*#__PURE__*/ React.createElement(ListItemIcon, {
        sx: {
            minWidth: 0,
            mr: {
                sm: desktopOpen ? 1 : "auto",
                xs: 3
            },
            justifyContent: "center",
            "&.MuiListItemIcon-root": {
                marginRight: 1
            }
        }
    }, /*#__PURE__*/ React.createElement("img", {
        width: 36,
        height: 36,
        src: ExcellonLogo,
        alt: "excellon-logo",
        id: "excellon-logo"
    })), /*#__PURE__*/ React.createElement(ListItemText, {
        sx: {
            opacity: {
                sm: desktopOpen ? 1 : 0,
                xs: 1
            }
        },
        primary: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                display: "inline",
                color: "#A8B5C2"
            },
            variant: "h2"
        }, t("Powered by Excellon"))),
        secondary: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                display: "inline",
                color: "#505862"
            },
            variant: "h6"
        }, versionNum.version))
    })))));
    var handleDotGridMenuClick = function (event) {
        trackButtonClick("ButtonClickEvent", "Drawer_Mobile_NineDot_Open", undefined);
        setdotgridIconAnchorEl(event.currentTarget);
    };
    var branchViewMobile = /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        gap: 2,
        paddingX: 1,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            placeContent: 'space-between'
        }
    }, /*#__PURE__*/ React.createElement(BajajDrawerLogoIcon, {
        sx: {
            height: '35.91px',
            width: '73.5px'
        }
    }), /*#__PURE__*/ React.createElement(MuiIconButton, {
        color: "inherit",
        "aria-label": "open drawer",
        onClick: handleDotGridMenuClick,
        edge: "start"
    }, /*#__PURE__*/ React.createElement(NineDotIcon, {
        sx: {
            height: '24px',
            width: '24px'
        }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        border: "1px solid #DEE4EB",
        spacing: 1.5,
        padding: '8px 12px',
        borderRadius: "8px",
        direction: "row",
        width: "100%",
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement("img", {
        height: 24,
        width: 24,
        src: BuildingIcon,
        alt: "workshop",
        id: "organization-icon"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'strong',
        maxWidth: 180,
        id: "organization-name"
    }, (_storedSelectedBranch = storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationName) !== null && _storedSelectedBranch !== void 0 ? _storedSelectedBranch : "---"))));
    var branchViewDesktop = /*#__PURE__*/ React.createElement(MuiStack, {
        paddingX: 1,
        paddingRight: 1.5,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        border: "1px solid #DEE4EB",
        spacing: 1.5,
        padding: '8px 12px',
        borderRadius: "8px",
        direction: "row",
        width: "100%",
        alignItems: 'center',
        justifyContent: desktopOpen ? 'flex-start' : 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement("img", {
        height: 24,
        width: 24,
        src: BuildingIcon,
        alt: "workshop",
        id: "organization-icon"
    })), desktopOpen && /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Tooltip, {
        title: (_storedSelectedBranch2 = storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationName) !== null && _storedSelectedBranch2 !== void 0 ? _storedSelectedBranch2 : ""
    }, /*#__PURE__*/ React.createElement(Typography, {
        noWrap: true,
        variant: "h3",
        maxWidth: 180
    }, (_storedSelectedBranch3 = storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationName) !== null && _storedSelectedBranch3 !== void 0 ? _storedSelectedBranch3 : "---")))));
    var onClickDrawerArrow = function () {
        trackButtonClick("ButtonClickEvent", "Drawer_Desktop_CloseArrow", undefined);
        dispatch(setIsLeftMenuOpen(!commonState.isMenuOpen));
    };
    return /*#__PURE__*/ React.createElement(MuiBox, {
        component: "nav",
        sx: {
            width: {
                DrawerWidth: DrawerWidth
            },
            flexShrink: 0
        },
        "aria-label": "sidebar-menus"
    }, !lgMode && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Drawer //only for mobile view
    , {
        variant: "temporary",
        open: mobileOpen,
        onClose: function () {
            handleMobileOpen(false);
        },
        ModalProps: {
            keepMounted: true
        },
        sx: {
            display: {
                xs: "block"
            },
            "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: DrawerWidth,
                paddingTop: "".concat(safeAreaMargin === null || safeAreaMargin === void 0 ? void 0 : safeAreaMargin.top, "px")
            }
        }
    }, /*#__PURE__*/ React.createElement(Loader, null), branchViewMobile, newDrawerContent), /*#__PURE__*/ React.createElement(Menu, {
        anchorEl: dotgridIconAnchorEl,
        id: "new-document-menu",
        open: openNewDocumentsMenu,
        onClose: handleDotGridMenu,
        sx: {
            overflow: 'visible',
            mt: 0.3,
            borderRadius: "8px"
            // top:'80px'
            // top:10
        },
        transformOrigin: {
            horizontal: 'left',
            vertical: 'top'
        },
        anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom'
        },
        MenuListProps: {
            'aria-labelledby': 'basic-button',
            sx: {
                padding: 0,
                whiteSpace: 'nowrap'
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: '12px',
                    border: '1px solid #DEE4EB'
                    // height: '228px',
                }
            }
        },
        disableScrollLock: true
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: ((_modules = modules(assignModuleData)) === null || _modules === void 0 ? void 0 : _modules.length) > 1 ? '228px' : '120px',
        height: 'auto',
        padding: '20px',
        gap: '20px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            height: '100%',
            padding: 0,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, (_modules2 = modules(assignModuleData)) === null || _modules2 === void 0 ? void 0 : _modules2.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6
        }, /*#__PURE__*/ React.createElement(MenuItem, {
            id: "new-document-".concat(index, "}"),
            dense: true,
            key: index,
            sx: {
                width: '84px',
                borderRadius: '8px',
                gap: '8px',
                height: '84px',
                justifyContent: 'center'
            },
            onClick: function (event) { return onModuleClickImage(event, item, index); }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            flexDirection: 'column',
            gap: "8px",
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement("img", {
            src: item === null || item === void 0 ? void 0 : item.src,
            alt: "dot-grid-icon",
            style: {}
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontWeight: 500,
                fontSize: '12px'
            }
        }, item === null || item === void 0 ? void 0 : item.DisplayName)))));
    })))))), lgMode && /*#__PURE__*/ React.createElement(DesktopDrawer //only for desktop view
    , {
        variant: "permanent",
        open: desktopOpen,
        onClose: function () {
            handleDesktopOpen(false);
        },
        ModalProps: {
            keepMounted: true
        },
        sx: {
            "& .MuiDrawer-paper": {
                boxSizing: "border-box"
            }
        }
    }, /*#__PURE__*/ React.createElement(DrawerHeader, null), branchViewDesktop, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("img", {
        style: {
            position: 'fixed',
            left: commonState.isMenuOpen ? DrawerWidth - 12 : 70,
            top: 78,
            cursor: 'pointer'
        },
        onClick: onClickDrawerArrow,
        width: 22,
        height: 22,
        alt: "arrow-icon",
        id: commonState.isMenuOpen ? "arrow-backword-icon" : "arrow-forword-icon",
        src: commonState.isMenuOpen ? ArrowBackwardIcon : ArrowForwardIcon
    })), newDrawerContentDesktopView), /*#__PURE__*/ React.createElement(Popover, {
        id: "sidebar-sub-menu",
        anchorEl: anchorEl,
        open: open,
        anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        onClose: handleClose,
        elevation: 1,
        disableScrollLock: true,
        slotProps: {
            paper: {
                sx: {
                    ml: 2
                }
            }
        },
        sx: {
            zIndex: 1300
        }
    }, /*#__PURE__*/ React.createElement(List, {
        sx: {
            minWidth: 270,
            px: 1
        },
        dense: true
    }, subMenuList === null || subMenuList === void 0 || (_subMenuList$sort2 = subMenuList.sort(function (a, b) { return a.Sequence - b.Sequence; })) === null || _subMenuList$sort2 === void 0 ? void 0 : _subMenuList$sort2.map(function (item, index) { /*#__PURE__*/ return React.createElement(ListItem, {
        key: index,
        onClick: function () { return onClickModuleSubMenus(item); },
        disableGutters: true,
        dense: true
    }, /*#__PURE__*/ React.createElement(ListItemButton, {
        sx: {
            borderRadius: 2,
            backgroundColor: selectedSubMenuItem === item.DisplayName ? 'primary.50' : 'none'
        },
        disableTouchRipple: true
    }, /*#__PURE__*/ React.createElement(ListItemText, {
        primary: /*#__PURE__*/ React.createElement(Typography, {
            fontSize: "lg",
            fontWeight: "strong",
            color: selectedSubMenuItem === item.DisplayName ? 'primary.main' : 'text.primary',
            id: item.DisplayName
        }, item.DisplayName)
    }))); }))));
};
